<template>
  <div class="classroom-detail-content">
    <div class="top-content">
      <a-icon type="left" @click="backListRouter" style="fontsize: 20px" />
      <div class="school-img">
        <img src="../../../assets/img/building_img.png" alt="" />
      </div>
      <div class="classroom-info">
        <div class="name">{{ +pageType == 1 ? '新增教室' : classroomDetailInfo.classroomName }}</div>
        <div class="building-name" v-if="pageType == 2">
          {{ classroomDetailInfo.campusName + '-' + classroomDetailInfo.buildingName }}
        </div>
      </div>
    </div>
    <div class="detail-content">
      <div class="classroom-tab">
        <div class="top-menu">
          <div
            :class="currentMenu === 'classroom' ? 'active-menu-item' : 'menu-item'"
            @click="handleClickMenu('classroom')"
          >
            教室信息
          </div>
          <div
            v-if="pageType == 2"
            :class="currentMenu === 'device' ? 'active-menu-item' : 'menu-item'"
            @click="handleClickMenu('device')"
          >
            设备接入
          </div>
          <div
            :class="currentMenu === 'advancedSetup' ? 'active-menu-item' : 'menu-item'"
            @click="handleClickMenu('advancedSetup')"
          >
            高级设置
          </div>
          <div
            :class="currentMenu === 'clientSetup' ? 'active-menu-item' : 'menu-item'"
            @click="handleClickMenu('clientSetup')"
          >
            客户端设置
          </div>
        </div>
        <div class="tab-content">
          <div class="classroom-detail" v-show="currentMenu === 'classroom'">
            <ClassroomInfo
              :buildingList="buildingList"
              :classroomInfo="classroomDetailInfo"
              @updateClassroomInfo="updateClassroomInfo"
            />
          </div>
          <div class="device-info" v-show="currentMenu === 'device'">
            <DeviceAccess ref="deviceRef" :classroomInfo="classroomDetailInfo" :deviceList="deviceListData" />
          </div>
          <div class="advanced_setup" v-show="currentMenu === 'advancedSetup'">
            <div class="CDN_config">
              <div class="CDN_config_title">CDN配置</div>
              <div class="CDN_config_body">
                <div class="CDN_config_body_title">CDN配置项</div>
                <div class="CDN_config_body_content">
                  <a-textarea
                    v-model="form.cdnLayoutConfig"
                    placeholder="请输入CDN配置"
                    :auto-size="{ minRows: 10, maxRows: 10 }"
                  />
                </div>
              </div>
            </div>
            <div class="screen_config">
              <div class="screen_config_title">屏幕配置</div>
              <div class="screen_config_body">
                <div class="screen_config_body_left">
                  <div class="screen_config_body_left_top">
                    <div class="left_top_title">
                      <span class="star">*</span>
                      <span>前屏屏幕数量</span>
                    </div>
                    <div class="left_top_content">
                      <a-select
                        :default-value="frontScreenCountDefaultValue"
                        :value="form.frontScreenCount"
                        placeholder="请选择屏幕数量"
                        style="width: 240px"
                        @change="handleFrontScreenCountChange"
                        :disabled="checkRunningLive"
                      >
                        <a-select-option :value="item.value" v-for="item in frontScreenCountOptions" :key="item.value">
                          {{ item.title }}
                        </a-select-option>
                      </a-select>
                    </div>
                  </div>
                  <div class="screen_config_body_left_bottom" v-show="form.frontScreenCount > 0">
                    <div class="left_bottom_title">
                      <span class="star">*</span>
                      <span>前屏屏幕数量</span>
                    </div>
                    <div class="left_bottom_content">
                      <a-textarea
                        v-model="form.frontScreenConfig"
                        placeholder="请输入屏幕配置"
                        :auto-size="{ minRows: 10, maxRows: 10 }"
                        :disabled="checkRunningLive"
                      />
                    </div>
                  </div>
                </div>
                <div class="screen_config_body_right">
                  <div class="screen_config_body_right_top">
                    <div class="right_top_title">
                      <span class="star">*</span>
                      <span>后屏屏幕数量</span>
                    </div>
                    <div class="right_top_content">
                      <a-select
                        :default-value="backendScreenCountDefaultValue"
                        :value="form.backendScreenCount"
                        placeholder="请选择屏幕数量"
                        style="width: 240px"
                        @change="handleBackendScreenCountChange"
                        :disabled="checkRunningLive"
                      >
                        <a-select-option
                          :value="item.value"
                          v-for="item in backendScreenCountOptions"
                          :key="item.value"
                        >
                          {{ item.title }}
                        </a-select-option>
                      </a-select>
                    </div>
                  </div>
                  <div class="screen_config_body_right_bottom" v-show="form.backendScreenCount > 0">
                    <div class="right_bottom_title">
                      <span class="star">*</span>
                      <span>后屏屏幕数量</span>
                    </div>
                    <div class="right_bottom_content">
                      <a-textarea
                        v-model="form.backendScreenConfig"
                        placeholder="请输入屏幕配置"
                        :auto-size="{ minRows: 10, maxRows: 10 }"
                        :disabled="checkRunningLive"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="advanced_setup_footer">
              <div class="save_btn" @click="handleAdvancedSetupSave">保存</div>
            </div>
            <div class="loading_mask" v-if="advancedSetupLoading">
              <a-spin />
            </div>
          </div>
          <div class="client-setup" v-show="currentMenu === 'clientSetup'">
            <ClientSetup ref="clientSetupRef" :classroomCode="classroomDetailInfo.classroomCode" />
          </div>
        </div>
      </div>
    </div>

    <a-modal
      title="提示"
      :zIndex="1000"
      :closable="false"
      :visible="showConfirmDialog"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <p>您修改的内容还未保存，确定要离开吗？</p>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DeviceAccess from './components/deviceAcess.vue'
import ClassroomInfo from './components/classroomInfo.vue'
import ClientSetup from './components/clientSetup.vue'

export default {
  components: {
    DeviceAccess,
    ClassroomInfo,
    ClientSetup
  },
  async created() {
    this.pageType = this.$route.query.pageType
    this.currentClassroomInfo = localStorage.getItem('currentClassroom')
      ? JSON.parse(localStorage.getItem('currentClassroom'))
      : {}
    await this.getBuildingList()
    if (this.pageType == 2) {
      await this.getClassroomDetail()
    }
  },
  data() {
    return {
      pageType: 1, // 1 新增教室 2 编辑教室
      currentMenu: 'classroom',
      currentClassroomInfo: {
        schoolCode: '',
        classroomCode: '',
        buildingId: '',
        classroomName: '',
        classroomType: '',
        administratorName: '',
        administratorPhone: '',
        maintainerName: '',
        maintainerPhone: '',
        longitude: '',
        latitude: ''
      },
      classroomDetailInfo: {},
      buildingList: [],
      deviceListData: [
        {
          deviceCode: '123',
          type: 1,
          roleType: '12',
          use: '123',
          status: 0
        }
      ],
      isSave: 0,
      showConfirmDialog: false,
      lastClassroomInfo: null,
      startClassroomInfo: null,
      jumpType: 0,
      form: {
        cdnLayoutConfig: '',
        frontScreenConfig: '',
        backendScreenConfig: '',
        frontScreenCount: '',
        backendScreenCount: ''
      },
      frontScreenCountOptions: [
        {
          title: 0,
          value: 0
        },
        {
          title: 1,
          value: 1
        },
        {
          title: 2,
          value: 2
        }
      ],
      backendScreenCountOptions: [
        {
          title: 0,
          value: 0
        },
        {
          title: 1,
          value: 1
        },
        {
          title: 2,
          value: 2
        }
      ],
      frontScreenCountDefaultValue: 0,
      backendScreenCountDefaultValue: 0,
      advancedSetupLoading: false,
      checkRunningLive: true
    }
  },
  computed: {
    ...mapGetters('userInfo', ['userInfo'])
  },
  mounted() {
    // 监听浏览器的返回按钮
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL)
      window.addEventListener('popstate', this.onCloseModal, false)
    }
    this.getCheckRunningLive()
    this.getAdvancedSettingQuery()
  },
  // 组件销毁阶段，解除监听返回按钮的事件
  destroyed() {
    window.removeEventListener('popstate', this.onCloseModal, false)
    localStorage.removeItem('lastClassroomInfo')
    localStorage.removeItem('classroomInfo')
  },

  methods: {
    async getClassroomDetail() {
      const res = await this.$http.getClassroomDetail({
        id: this.$route.query.id
      })
      if (res.code === 200 && res.rt) {
        this.classroomDetailInfo = res.rt
        this.classroomDetailInfo.selectBuilding = [res.rt.campusId, res.rt.buildingId]
      }
      console.log('getClassroomDetail🔧:>>>>>>>', res, 'classroomDetail.vue')
    },
    async getBuildingList() {
      const res = await this.$http.getClassroomFilterTree({
        schoolCode: this.$route.query.selectSchool
      })
      if (res.code === 200 && res.rt) {
        this.buildingList = this.handleData(res.rt.campusList, 1)
        console.log('this.buildingList🔧:>>>>>>>', this.buildingList, 'classroomInfo.vue')
      }
    },
    handleData(data, level) {
      data.length &&
        data.forEach((children) => {
          children.level = level
          children.label = children.campusName || children.buildingName || null
          children.value = children.campusId || children.buildingId || null
          if (children.level == 1 && (!children.buildingInfos || !children.buildingInfos.length)) {
            children.disabled = true
          }
          if (children.buildingInfos && children.buildingInfos.length) {
            children.children = children.buildingInfos
            this.handleData(children.buildingInfos, 2)
          }
        })
      return data
    },
    handleShowTip(type) {
      this.isSave = localStorage.getItem('isSave')
      this.startClassroomInfo = localStorage.getItem('classroomInfo')
      this.lastClassroomInfo = localStorage.getItem('lastClassroomInfo')
      if (!this.lastClassroomInfo || this.startClassroomInfo == this.lastClassroomInfo) {
        // 内容无变化，直接跳转
        this.handlePageJump(type)
      } else {
        if (this.isSave > 0) {
          this.handlePageJump(type)
        } else {
          this.jumpType = type
          this.showConfirmDialog = true
        }
      }
    },
    handlePageJump(type) {
      if (type === 1) {
        this.$router.push({
          name: 'ClassRoomManagement'
        })
      } else {
        this.$router.go(-1)
      }
    },
    backListRouter() {
      this.handleShowTip(1)
    },
    onCloseModal() {
      this.handleShowTip(2)
    },
    handleOk() {
      this.showConfirmDialog = false
      this.handlePageJump(this.jumpType)
    },
    handleCancel() {
      this.showConfirmDialog = false
    },
    handleClickMenu(menu) {
      this.currentMenu = menu
      if (menu == 'device') {
        console.log('111🔧:>>>>>>>', 111, 'classroomDetail.vue')
        this.$refs.deviceRef.getDeviceListData()
      } else if (menu == 'clientSetup') {
        this.$refs.clientSetupRef.getClientSetup()
      }
    },
    async updateClassroomInfo(data) {
      console.log('data🔧:>>>>>>>', data, 'classroomDetail.vue')
      if (data.type == 1) {
        // 新增
        const createRes = await this.$http.createClassroom(data.params)
        console.log('createRes🔧:>>>>>>>', createRes, 'classroomDetail.vue')
        if (createRes.code === 200 && createRes.rt.resultStatus == -1) {
          return this.$message.error(createRes.rt.resultMessage)
        }
        if (createRes.code === 200 && createRes.rt.resultStatus == 1) {
          this.$message.success('新增成功')
          setTimeout(() => {
            this.$router.push({
              name: 'ClassRoomManagement'
            })
          }, 100)
        }
      } else {
        // 编辑
        const editRes = await this.$http.updateClassroom(data.params)
        console.log('editRes🔧:>>>>>>>', editRes, 'classroomDetail.vue')
        if (editRes.code === 200 && editRes.rt.resultStatus == -1) {
          return this.$message.error(editRes.rt.resultMessage)
        }
        if (editRes.code === 200 && +editRes.rt.resultStatus === 1) {
          this.$message.success('保存成功')
        }
      }
    },
    handleFrontScreenCountChange(value) {
      this.form.frontScreenCount = value
    },
    handleBackendScreenCountChange(value) {
      this.form.backendScreenCount = value
    },
    async getCheckRunningLive() {
      try {
        const result = await this.$http.checkRunningLive({ classroomCode: this.$route.query.classroomCode })
        if (result.code !== 200) return
        this.checkRunningLive = result.rt
      } catch (err) {
        console.log(err)
      }
    },
    async getAdvancedSettingQuery() {
      try {
        const result = await this.$http.advancedSettingQuery({ id: this.$route.query.id })
        const advancedSettingDetail = {
          ...(result.rt || {}),
          id: this.$route.query.id
        }
        Object.assign(this.form, {
          ...advancedSettingDetail
        })
        this.frontScreenCountDefaultValue = this.form.frontScreenCount
        this.backendScreenCountDefaultValue = this.form.backendScreenCount
      } catch (err) {
        console.log(err)
      }
    },
    async handleAdvancedSetupSave() {
      try {
        const params = {
          ...this.form
        }
        this.advancedSetupLoading = true
        const result = await this.$http.advancedSettingEdit(params)
        this.advancedSetupLoading = false
        if (result.code !== 200) return this.$message.error('保存失败')
        const { resultStatus } = result.rt
        if (resultStatus !== 1) return this.$message.error('保存失败')
        this.$message.success('保存成功')
        Object.assign(this.form, {
          cdnLayoutConfig: '',
          frontScreenConfig: '',
          backendScreenConfig: '',
          frontScreenCount: '',
          backendScreenCount: ''
        })
        this.getAdvancedSettingQuery()
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.top-content {
  width: 100%;
  height: 110px;
  padding: 16px;
  background: #fff;
  display: flex;
  align-items: center;
  .school-img {
    margin-left: 20px;
    width: 80px;
    height: 77px;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .classroom-info {
    margin-left: 32px;
    color: #1e2228;
    text-align: left;
    .name {
      line-height: 40px;
      font-size: 28px;
      font-weight: 600;
    }
    .building-name {
      margin-top: 8px;
      text-align: left;
      font-size: 14px;
    }
  }
}
.detail-content {
  margin-top: 16px;
  width: 100%;
  padding: 16px;
  height: auto;
  min-height: calc(100vh - 110px - 96px - 16px);
  background: #fff;
}
.classroom-tab {
  width: 100%;
  height: 100%;
  .top-menu {
    display: flex;
    align-items: center;
    height: 36px;
    border-bottom: 1px solid #ebedf0;
  }
  .menu-item {
    width: 100px;
    height: 36px;
    text-align: center;
    line-height: 36px;
    border: 1px solid #d5d7df;
    background-color: #f7f8fa;
    cursor: pointer;
  }
  .active-menu-item {
    width: 100px;
    height: 36px;
    text-align: center;
    line-height: 36px;
    border-top: 2px solid #5f60d3;
    border-left: 1px solid #d5d7df;
    border-right: 1px solid #d5d7df;
    background-color: #fff;
    cursor: pointer;
  }

  .tab-content {
    // position: relative;
    width: 100%;
    height: calc(100vh - 76px - 110px - 32px - 36px - 40px);
    padding-top: 16px;
    .classroom-detail {
      width: 100%;
      height: 100%;
    }
    .advanced_setup {
      width: 100%;
      height: 100%;
      text-align: left;
      position: relative;
      .CDN_config {
        .CDN_config_title {
          font-size: 14px;
          font-weight: 600;
          color: #1e2228;
        }
        .CDN_config_body {
          display: flex;
          padding-left: 40px;
          margin-top: 16px;
          .CDN_config_body_title {
            font-size: 14px;
            color: #515560;
            margin-right: 16px;
          }
          .CDN_config_body_content {
            width: 456px;
            height: auto;
          }
        }
      }
      .screen_config {
        margin-top: 32px;
        .screen_config_title {
          font-size: 14px;
          font-weight: 600;
          color: #1e2228;
        }
        .screen_config_body {
          display: flex;
          padding-top: 16px;
          .screen_config_body_left {
            .screen_config_body_left_top {
              display: flex;
              align-items: center;
              padding-left: 16px;
              .left_top_title {
                margin-right: 16px;
                .star {
                  color: #ff5555;
                }
              }
              // .left_top_content {
              // }
            }
            .screen_config_body_left_bottom {
              display: flex;
              align-items: flex-start;
              padding-left: 16px;
              margin-top: 8px;
              .left_bottom_title {
                margin-right: 16px;
                opacity: 0;
                .star {
                  color: #ff5555;
                }
              }
              .left_bottom_content {
                width: 456px;
                height: auto;
              }
            }
          }
          .screen_config_body_right {
            margin-left: 50px;
            .screen_config_body_right_top {
              display: flex;
              align-items: center;
              padding-left: 16px;
              .right_top_title {
                margin-right: 16px;
                .star {
                  color: #ff5555;
                }
              }
              // .right_top_content {
              // }
            }
            .screen_config_body_right_bottom {
              display: flex;
              align-items: flex-start;
              padding-left: 16px;
              margin-top: 8px;
              .right_bottom_title {
                margin-right: 16px;
                opacity: 0;
                .star {
                  color: #ff5555;
                }
              }
              .right_bottom_content {
                width: 456px;
                height: auto;
              }
            }
          }
        }
      }
      .advanced_setup_footer {
        width: 100%;
        height: auto;
        border-top: 1px solid #e7e7e7;
        margin-top: 20px;
        display: flex;
        justify-content: center;
        padding-top: 20px;
        .save_btn {
          width: 104px;
          height: 38px;
          background: #5f60d3;
          border-radius: 4px;
          font-size: 14px;
          color: #ffffff;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          user-select: none;
          &:hover {
            background: #494ba4;
          }
          &:active {
            background: #5f60d3;
          }
        }
      }
      .loading_mask {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: rgba(255, 255, 255, 0.7);
        cursor: not-allowed;
      }
    }
  }
}
</style>
